<mat-card class="next-changeover" *ngIf="this.nextChangover">
  <span class="label no-break up-next">Up Next:</span>
  <table aria-describedby="nextChangover" class="next-changeover-details">
    <tr>
      <th scope="col"></th>
      <th scope="col"></th>
    </tr>
    <tr>
      <td>
        <mat-icon>label_outline</mat-icon>
      </td>
      <td><span>{{this.nextChangover.type}}</span></td>
    </tr>
    <tr>
      <td>
        <mat-icon>trending_flat</mat-icon>
      </td>
      <td>
        <span>{{this.nextChangover.to}}</span>
      </td>
    </tr>
    <tr>
      <td>
        <mat-icon>event</mat-icon>
      </td>
      <td><span>{{this.nextScheduledTime}}</span></td>
    </tr>
  </table>
  <button type="button"
          class="start-button"
          aria-label="Finalise"
          color="accent"
          mat-flat-button
          (click)="this.startNext()">START</button>
</mat-card>

<app-spinner [promise]="this.modelFetchPromise"></app-spinner>

<ng-container *ngIf="!this.modelFetchPromise">
  <div *ngIf="this.nothingScheduled" class="centering-container nothing-scheduled">
    <div>
      <mat-icon>event_busy</mat-icon>
    </div>
    <div>
      No changeovers scheduled
    </div>
  </div>

  <div *ngIf="!this.nothingScheduled && this.noCurrentChangeover" class="centering-container no-current-changeover">
    <div>
      <mat-icon>calendar_today</mat-icon>
    </div>
  </div>

  <div class="task-list-area" *ngIf="!this.noCurrentChangeover">
    <app-changeover-details [changeover]="this.currentChangeover"></app-changeover-details>

    <app-task-list #taskList class="task-list" [model]="this.currentChangeover"
                   (taskSelected)="this.onTaskSelected($event)"></app-task-list>
  </div>
</ng-container>